import { Dimensions } from '../../../types/dimensions.js';

/**
 * Determines if toolbar fits well in bounds, depending on the available space of the container
 *
 * @param toolbarWidth -
 * @param boundSize -
 */
export function doesFitInBounds(
  toolbarWidth: number,
  boundSize: Dimensions,
): boolean {
  const { width: boundaryWidth } = boundSize;

  return toolbarWidth < boundaryWidth / 2;
}
